import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { commonFormStyles, commonLHCOmponentStyle } from '@ahoy/ui/common/styles/common-styles';
import { QuestionsService } from '@APP/services/questions-service';
import { UserService } from '@APP/services/user-service';
import { customElement, property, state } from 'lit/decorators';
import { DeviceAwareComponent } from './device-aware-component';
import { html, css, PropertyValues } from 'lit';
import { Question } from '@APP/model/question';
import { t } from '@APP/utils/locale';
import { unsafeHTML } from 'lit/directives/unsafe-html';


type OwnDeps = {
  questionsService: QuestionsService;
  userService: UserService;
};

@requires(QuestionsService.serviceName, UserService.serviceName)
@customElement('lh-accept-terms')
export class LHAcceptTerms extends DepInjMixin<OwnDeps>(DeviceAwareComponent) {

  static get baseStyles() {
    return [
      commonLHCOmponentStyle(css),
      commonFormStyles(css),
      css`
        :host([hidden]) {
          display: none;
      }
      :host {
        display: grid;
        grid-gap: 2rem;
      }
      .text_massege{
        font-size: 2.5rem;
        color: var(--c-text);
      }
      #error {
        font-size: 2rem;
        display: block;
        margin: -1rem 0 1rem;
        color: var(--c-err);
      }
      a {
        font-size: 2rem;
        color: var(--c-link);
        text-decoration: underline;
        cursor: pointer;
        width: fit-content;
        margin: 0 4rem;
      }
      .text-terms {
        font-size: var(--question-label-size, 2rem);
        color: rgba(18, 18, 19, 0.6);
        display: block;
        margin-left: 4rem;
      }     
      :host checkbox-input{
        display: block;
        height: 0rem;
      }
    `,
    ];
  };

  static get mobileStyles() {
    return [
      css`
        .text-terms { margin: 0 1rem 0 5.5rem; }
      `,
    ];
  }

  @property({ type: String, attribute: 'question-id' })
    questionId = '';

  @state()
    question: Question | undefined;

  @state()
    showMore: boolean = false;

  @state()
    showErrors: boolean = false;

  @state()
    isValid: boolean = false;

  private accpet = this.deps.userService.store['accept'];

  constructor() {
    super();
  }

  updated(p: PropertyValues<this>) {

    if (p.has('questionId')) {
      this.question = this.deps.questionsService.model.getQuestionById(this.questionId) as Question | undefined;
    }

  }

  handleShowMore() {
    this.showMore = true;
  }

  handleChange(e: CustomEvent<boolean>) {
    const value = e.detail;
    this.accpet = value;
    this.deps.userService.store['accept'] = value;
    this.showErrors = false;
  }

  public runValidations() {
    this.isValid = this.accpet;
    if (!this.isValid) {
      this.showErrors = true;
    }
  }

  public getErrors(): string {
    if (this.showErrors)
      return t('ValidErrAccpetTerms');
    else
      return '';
  }

  renderContent() {
    const isLoogedIn = this.deps.userService.isLoggedIn;
    const status = this.deps.questionsService.model.getStatus();
    if (!this.question || (isLoogedIn && status != 'Mem' && this.accpet)) {
      return html``;
    }
    const textWithoutLinks = t('T_Accept_Terms1');
    // Make the phrase "Terms and Conditions" linkable with the following address - https://ahoy.insure/terms-and-conditions/
    // Make the phrase "Privacy Policy" linkable with the following address - https://ahoy.insure/privacy-policy/
    const textWithLinks = textWithoutLinks.replace(
      /Terms and Conditions/g,
      '<a href="https://ahoy.insure/terms-and-conditions/" target="_blank" style="color: #744BDA; text-decoration: none;margin:0">Terms and Conditions</a>',
    ).replace(
      /Privacy Policy/g,
      '<a href="https://ahoy.insure/privacy-policy/" target="_blank" style="color: #744BDA; text-decoration: none; margin:0">Privacy Policy</a>',
    );
    const textWithLinksHTML = html`${unsafeHTML(textWithLinks)}`;

    return html`
      <span class="entry">
        ${this.showErrors ?
    html`
          <span id='error'>${t('ValidErrAccpetTerms')}</span>
        `
    : void 0}
        <checkbox-input .customizations=${true} .checkedInput=${this.accpet} @change=${this.handleChange}> 
        </checkbox-input>
        <span class="text-terms">${t('T_Accept_Terms')}</span>
        ${this.showMore ? html`<span class="text-terms"> ${textWithLinksHTML}</span>` : html`
            <a link pop @click=${this.handleShowMore}>
                  ${t('T_Show_More')}
            </a>
        `}
      </span>
  `;
  }

}